import React, { Component } from 'react'
import { connect } from 'react-redux'
import { signOutUser } from '../redux-token-auth-config'

class SignOutLink extends Component {
  signOut (e) {
    e.preventDefault()
    if(window.confirm('Are you sure?')) {
      const { signOutUser } = this.props
      signOutUser()
    }
  }

  render () {
    return <a style={{cursor: 'pointer'}} onClick={this.signOut.bind(this)}>Sign Out</a>
  }
}

export default connect(
  null,
  { signOutUser },
)(SignOutLink)


// WEBPACK FOOTER //
// ./src/authentication/javascripts/components/SignOutLink.jsx